import type { WatchlistDto } from "../api/watchlist.api";
import type { ReleaseCardModel } from "features/catalog/components/HomeLanding/HomeLandingModel";

/**
 * Maps a watchlist row to the same model `ReleaseCard` / home landing use.
 * `id` prefers `catalogAssetId` so navigation and dummy-data asset matching work.
 * Description comes from the catalog dummy asset when linked or title-matched;
 * "Added on …" is always appended (same idea as the old `{title} - Added on …` line).
 */
export function watchlistDtoToReleaseCardModel(
  row: WatchlistDto,
  thumbnailSrc?: string
): ReleaseCardModel {
  const id = String(row.assetUploadId || row.id);
  const priceStr =
    row.price === 0 ? "Free" : `€${row.price.toFixed(2)}`;
  const addedLine = `Added on ${new Date(row.addedAt).toLocaleDateString()}`;
  const description = `${row.title} — ${addedLine}`;

  return {
    id,
    title: row.title,
    description,
    price: priceStr,
    role: "CREATOR",
    thumbnailSrc: thumbnailSrc || "/images/watchlistThumbnail.png",
    picks: [
      { label: "Status", value: row.status },
      { label: "Language", value: row.language },
      { label: "Price", value: priceStr },
    ],
  };
}